module.exports = __webpack_public_path__ + "media/images/sidebar-bg-admin-b60b5ff3.jpg";